import { Injectable } from '@angular/core';
import { AppState } from 'src/app/app.reducer';
import { EagerSelectEffects } from '../../select/eager-select/eager-select-effects';
import { phoneNumberOptionActions } from './phone-number-option.actions';
import { phoneNumberOptionSelectors } from './phone-number-option.reducer';

@Injectable({ providedIn: 'root' })
export class PhoneNumberOptionEffects {
   defaultFields: string[] = ['phoneNumber', 'displayName', 'phoneNumberId', 'allowOutboundCalls', 'faxExtensionId'];

   defaultOrderingOptions: string[] = ['DisplayName:asc'];

   staticFilters: string[] = [];

   load = this.eagerSelectEffects.createEagerSelectorLoadEffect(
      phoneNumberOptionSelectors.selectState,
      'phoneNumbers',
      this.defaultFields,
      this.defaultOrderingOptions,
      phoneNumberOptionActions,
      this.staticFilters
   );

   constructor(private eagerSelectEffects: EagerSelectEffects<AppState>) {}
}
